import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { AuthorizationGuard } from '@shared/authentication/authentication.guard';
import { ITEMSTOCK_PAGE } from '@shared/constants/routing-constants';

const routes: Routes = [
  {
    path: ITEMSTOCK_PAGE,
    canActivate: [AuthorizationGuard],
    loadComponent: () =>
      import('./pages/item-stock/kfm-item-stock-page.component').then(
        (m) => m.KfmItemStockPageComponent,
      ),
  },
];

export const itemStockRoutingModule: ModuleWithProviders<RouterModule> =
  RouterModule.forChild(routes);
